import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from "features/account";
import { checkStillConnected } from "features/auth";
import { motion } from 'framer-motion';
import { encryptApiBodyFromString } from "shared/api/cryptApiBody";
import logoIdTracker from "../assets/img/logo_ID-Protect-blanc-icon.png";


const ProtectedRoutes = () => {
  const { user } = useContext(UserContext);
  const [isAuthorized, setIsAuthorized] = useState<null | boolean>(null);

  useEffect(() => {
    const type = localStorage.getItem("type") ?? 'individual';
    if (user?.email == null) {
      checkStillConnected(type).then((result) => {
        setIsAuthorized(result);
      });
    }
  }, []);

  if (user?.email != null) {
    return <Outlet />;
  }

  if (isAuthorized === null) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100 w-100 bg-gradient-to-r from-gray-50 to-gray-100">
        <motion.div
          className="relative flex items-center justify-center"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          {/* Cercle animé */}
          <motion.div
            className="absolute rounded-full border-4 border-blue-400"
            style={{ width: 150, height: 150 }}
            animate={{
              scale: [1, 1.4, 1],
              opacity: [0.8, 0.2, 0.8],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />

          {/* Logo qui pulse */}
          <motion.div
            animate={{
              scale: [1, 1.1, 1],
              rotate: [0, 10, -10, 0],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <img
              src={logoIdTracker}
              alt=""
            />
          </motion.div>
        </motion.div>
      </div>
    );
  }

  return isAuthorized ? <Outlet /> : <RetourHome/>;
};

const RetourHome = () => {
  return  <Navigate to={`/?error=${encryptApiBodyFromString('Votre session a expiré')}`} />;
}

export default ProtectedRoutes;
